/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { InscriptionSuspensionDto } from './InscriptionSuspensionDto';
import {
    InscriptionSuspensionDtoFromJSON,
    InscriptionSuspensionDtoFromJSONTyped,
    InscriptionSuspensionDtoToJSON,
} from './InscriptionSuspensionDto';

/**
 * 
 * @export
 * @interface InscriptionSuspensionDtoPaginatedResults
 */
export interface InscriptionSuspensionDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof InscriptionSuspensionDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<InscriptionSuspensionDto>}
     * @memberof InscriptionSuspensionDtoPaginatedResults
     */
    results?: Array<InscriptionSuspensionDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof InscriptionSuspensionDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the InscriptionSuspensionDtoPaginatedResults interface.
 */
export function instanceOfInscriptionSuspensionDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionSuspensionDtoPaginatedResultsFromJSON(json: any): InscriptionSuspensionDtoPaginatedResults {
    return InscriptionSuspensionDtoPaginatedResultsFromJSONTyped(json, false);
}

export function InscriptionSuspensionDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionSuspensionDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(InscriptionSuspensionDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function InscriptionSuspensionDtoPaginatedResultsToJSON(value?: InscriptionSuspensionDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(InscriptionSuspensionDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

